import { NavLink } from "react-router";
import PropTypes from "prop-types";
import { useState } from "react";
import "../../style/import-Chillax.css";
import "../../style/Header.css";
// img
import defaultProfilPicture from "/images/person-circle.svg";



const Header = ({
    hasProfil = true,
    appName = "Tracks-List",
    linkList = [
        { to: "/", label: "Accueil"},
        { to: "/play/param", label: "Jouer"},
        { to: "/collection", label: "Collection"},
        { to: "/community", label: "Communauté"},
        { to: "/admin", label: "Administrateur", needAdmin: true}
    ],
    imageProfil = defaultProfilPicture,
    connected = false,
    responsive = true,
    admin = false
}) => {
  const [extendedMenu, setExtendedMenu] = useState(false);

  const handleExtendMenu = () => {
    extendedMenu ? setExtendedMenu(false) : setExtendedMenu(true);
  };

  return (
    <header className={`header ${extendedMenu && responsive && `unwrap`} ${responsive || `no-responsive`}`}>
        <div className="header-left">
            <NavLink className="header-title" to="/" tabIndex={1}>{appName}</NavLink>
        </div>
        <div className="header-right">
            <ul className="header-linkList">
                {
                    linkList.map((navItem) => 
                        !navItem.needAdmin || (navItem.needAdmin === true && admin===true) ? <li className="header-linkLi" key={navItem.to}>
                            <NavLink to={navItem.to} tabIndex={extendedMenu ? `0` : `-1`} aria-hidden={extendedMenu && responsive ? `true` : `false`} className={
                                (({ isActive }) => `header-link ${isActive ? `active` : ``}`)
                                }>
                                {navItem.label}
                            </NavLink>
                        </li> : null
                    )
                }
            </ul>
            {hasProfil &&
                <NavLink className="header-profil" to={connected?`/profil`:`/login`}  tabIndex={extendedMenu && responsive ? null : `-1`} aria-hidden={extendedMenu && responsive ? `true` : `false`}>
                    <img className={imageProfil === defaultProfilPicture ?``:`spinning`} src={imageProfil === defaultProfilPicture ? defaultProfilPicture : `${import.meta.env.BASE_URL}${imageProfil}`} alt="Login"/>
                </NavLink>
            }
        </div>
        <button className="header-burgerButton" onClick={responsive ? handleExtendMenu : undefined} tabIndex={2}>
            <svg viewBox="0 0 500 500">
                <rect className="line line-top" fill="currentColor" height="40" rx="20" ry="20" />
                <rect className="line line-center" fill="currentColor" height="40" y="230" rx="20" ry="20" />
                <rect className="line line-bottom" fill="currentColor" height="40" y="460" rx="20" ry="20" />
            </svg>
        </button>
    </header>
  );
};

Header.propTypes = {
    connected: PropTypes.bool,
};

export default Header;